import axios from "axios";
import { VERIFY_OTP } from "./URLs";
import { setAuthenticatedUser } from "../stores/authenticated-user.store";
import store from "../stores";

const instance = axios.create({
    // baseURL: 'https://prr-apidev.aws.paysign.com', // Dev Env
    // baseURL: 'https://prrapptest.aws.paysign.com', // Test Env
    // baseURL: 'https://prr-apistage.aws.paysign.com', // Staging Env
    // baseURL: 'https://prr-api.aws.paysign.com', // Prod Env 
    baseURL: process.env.REACT_APP_BASE_URL_BACK_END || 'http://localhost:8096',
    withCredentials: true,
});

instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const response = error.response;
        if (
            response &&
            response.config.url !== VERIFY_OTP &&
            response.status === 401
        ) {
            store.dispatch(setAuthenticatedUser(null));
            window.location = "/auth/login";
        }
        return Promise.reject(error);
    },
);

export default instance;